import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndicatorsSidenavComponent } from './indicators-sidenav/indicators-sidenav.component';
import { UtilsD3Module } from '@compass/utils/d3';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, UtilsD3Module, MatIconModule],
  declarations: [IndicatorsSidenavComponent],
  exports: [IndicatorsSidenavComponent],
  providers: []
})
export class IndicatorsModule { }
